// A parts CSV whose part number column we do not know comes in with every part number blank
// (Ajax Paving's CAT export, Nov 3, gf-o10ls). Lines with only a description are allowed, so
// the upload still takes the file, but when most lines have no part number the buyer reads
// why before adding them (gf-om9fa).

export const blankPartNumberWarning = (parts: { partNumber: string }[]) => {
  const blank = parts.filter((part) => part.partNumber.trim() === '').length

  if (parts.length === 0 || blank * 2 <= parts.length) return null

  return (
    `${blank} of ${parts.length} ${parts.length === 1 ? 'line has' : 'lines have'} ` +
    'no part number. Part numbers are read from a column named Part Number, Part No, MPN, ' +
    'PN or Item. Check the column names in your file, or add the parts with descriptions only.'
  )
}
